import { render } from "./ServiceSupport.vue?vue&type=template&id=5aebb490&scoped=true"
import script from "./ServiceSupport.vue?vue&type=script&lang=js"
export * from "./ServiceSupport.vue?vue&type=script&lang=js"

import "./ServiceSupport.vue?vue&type=style&index=0&id=5aebb490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aebb490"]])

export default __exports__